module.exports = __webpack_public_path__ + "img/Jump Casting108.5f004ca0.jpg";